import React from "react";
import { Stack, Typography } from "@mui/material";
import NothingHereYet from "src/static/images/nothing_here_yet.svg";
import EmptySearch from "src/static/images/empty_search.svg";

const NoRowsOverlay = ({ isFilteringOn, hasRows, noRowsText, noResultsText, noResultsDescription }) => {
  if (isFilteringOn && !hasRows) {
    return (
      <Stack data-testid='hyro-table-no-results' sx={{ position: "sticky", inset: 0, height: "100%", justifyContent: "center", alignItems: "center", backgroundColor: "system.0" }}>
        <img width={103} height={56} src={EmptySearch} alt='' />
        <Typography variant="subtitle1" color="grey.700" sx={{ mt: 2 }}>{noResultsText}</Typography>
        {noResultsDescription && <Typography variant="body2" color="grey.500" sx={{ mt: .5 }}>{noResultsDescription}</Typography>}
      </Stack>
    );
  } if (!hasRows) {
    return (
      <Stack data-testid='hyro-table-no-rows' sx={{ position: "sticky", inset: 0, height: "100%", justifyContent: "center", alignItems: "center", backgroundColor: "system.0" }}>
        <img width={103} height={56} src={NothingHereYet} alt='' />
        <Typography mt={2} variant="body1" color="text.800">
          {noRowsText}
        </Typography>
      </Stack>
    );
  }

  return null;
};

export default NoRowsOverlay;
